<template>
  <div class="tut-overlay" v-if="aberto" @click.self="fechar">
    <div class="tut-painel">
      <div class="tut-cabecalho">
        <div class="tut-titulo">
          <i class="bi bi-mortarboard"></i>
          <span>{{ tituloModal }}</span>
        </div>
        <button class="tut-fechar" :title="$t('fechar')" @click="fechar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="tut-corpo">
        <div class="tut-carregando" v-if="carregando">
          <i class="bi bi-arrow-repeat girando"></i>
          <span>{{ $t('carregando_tutorial') }}</span>
        </div>

        <div class="tut-vazio" v-else-if="!regras.length">
          {{ $t('tutorial_indisponivel') }}
        </div>

        <div class="tut-regra" v-for="regra in regras" :key="regra.id">
          <div class="tut-regra-cabecalho" v-if="regra.caminho || regra.resumo">
            <small class="tut-regra-caminho" v-if="regra.caminho">{{ regra.caminho }}</small>
            <p class="tut-regra-resumo" v-if="regra.resumo" v-html="formatarTexto(regra.resumo)"></p>
          </div>

          <div class="tut-grupo" v-for="(grupo, gIndex) in regra.grupos" :key="gIndex">
            <h4 class="tut-grupo-titulo" v-if="grupo.titulo">{{ grupo.titulo }}</h4>

            <div class="tut-cards-grid">
            <div class="tut-card" v-for="card in grupo.cards" :key="card.numero">
              <div class="tut-card-titulo">{{ card.titulo }}</div>

              <div
                class="tut-item"
                :class="classeTom(item.tom)"
                v-for="(item, iIndex) in card.itens"
                :key="iIndex"
              >
                <span class="tut-item-rotulo" v-if="item.rotulo">{{ item.rotulo }}</span>

                <p
                  class="tut-item-texto"
                  :class="{ 'tut-item-formula': item.tipo === 'formula', 'tut-item-exemplo': item.tipo === 'example' }"
                  v-if="item.texto"
                  v-html="formatarTexto(item.texto)"
                ></p>

                <ul class="tut-topicos" v-if="item.topicos && item.topicos.length">
                  <li
                    class="tut-topico"
                    :class="[classeTom(topico.tom), { 'tut-topico-titulo': topico.titulo }]"
                    v-for="(topico, tIndex) in item.topicos"
                    :key="tIndex"
                    v-html="formatarTexto(topico.texto)"
                  ></li>
                </ul>
              </div>
            </div>
            </div>
          </div>

          <div class="tut-prints" v-if="regra.prints && regra.prints.length">
            <div class="tut-print" v-for="(print, pIndex) in regra.prints" :key="pIndex">
              <img v-if="print.url || print.imagem_url" :src="print.url || print.imagem_url" :alt="regra.tela">
              <span
                class="tut-print-ponto"
                v-for="(ponto, ptIndex) in print.pontos"
                :key="ptIndex"
                :style="{ left: ponto.x + '%', top: ponto.y + '%' }"
                :title="ponto.texto"
              >{{ ponto.card }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { formatarTexto, classeTom } from '@/utils/tutorialFormat.js'

export default {
  name: 'TutorialModal',
  computed: {
    aberto() {
      return this.$store.getters['tutorial/aberto']
    },
    carregando() {
      return this.$store.getters['tutorial/carregando']
    },
    pacote() {
      return this.$store.getters['tutorial/dados']
    },
    regras() {
      return (this.pacote && this.pacote.itens) || []
    },
    tituloModal() {
      if (this.regras.length === 1) return this.regras[0].tela
      return this.$t('tutorial_desta_tela')
    }
  },
  watch: {
    aberto(valor) {
      if (valor) {
        window.addEventListener('keydown', this.aoApertarEsc)
      } else {
        window.removeEventListener('keydown', this.aoApertarEsc)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.aoApertarEsc)
  },
  methods: {
    formatarTexto,
    classeTom,
    fechar() {
      this.$store.dispatch('tutorial/fechar')
    },
    aoApertarEsc(evento) {
      if (evento.key === 'Escape') this.fechar()
    }
  }
}
</script>

<style scoped>
.tut-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8vh;
  z-index: 100000;
}

.tut-painel {
  width: 94%;
  max-width: 980px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: var(--rd-radius-lg);
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

.tut-cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e4e4e7;
  flex-shrink: 0;
}

.tut-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #18181b;
  font-size: 14px;
  font-weight: 600;
}

.tut-fechar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: none;
  color: #71717a;
  cursor: pointer;
}

.tut-fechar:hover {
  background: #f4f4f5;
  color: #18181b;
}

.tut-corpo {
  overflow-y: auto;
  padding: 16px;
  background: #ffffff;
}

.tut-carregando,
.tut-vazio {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 24px 8px;
  color: #71717a;
  font-size: 13px;
  text-align: left;
}

.girando {
  animation: tut-girar 1s linear infinite;
}

@keyframes tut-girar {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.tut-regra + .tut-regra {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e4e4e7;
}

.tut-regra-cabecalho {
  margin-bottom: 16px;
}

.tut-regra-caminho {
  display: block;
  color: #71717a;
  font-size: 11px;
  margin-bottom: 4px;
}

.tut-regra-resumo {
  margin: 0;
  color: #52525b;
  font-size: 13px;
  line-height: 1.5;
}

.tut-grupo + .tut-grupo {
  margin-top: 18px;
}

.tut-grupo-titulo {
  margin: 0 0 10px;
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
}

.tut-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  align-items: start;
}

@media (max-width: 720px) {
  .tut-cards-grid {
    grid-template-columns: 1fr;
  }
}

.tut-card {
  background: #f9fafb;
  border: 1px solid #e4e4e7;
  border-radius: var(--rd-radius-sm);
  padding: 12px 14px;
}

.tut-card-titulo {
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
}

.tut-item {
  padding-left: 10px;
  border-left: 2px solid #d4d4d8;
}

.tut-item + .tut-item {
  margin-top: 12px;
}

.tut-item-rotulo {
  display: block;
  color: #71717a;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 3px;
}

.tut-item-texto {
  margin: 0;
  color: #27272a;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.tut-item-formula {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: var(--rd-radius-sm);
  padding: 8px 10px;
}

.tut-item-exemplo {
  font-style: italic;
  color: #52525b;
}

.tut-topicos {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tut-topico {
  position: relative;
  padding-left: 14px;
  font-size: 13px;
  line-height: 1.5;
  color: #27272a;
}

.tut-topico::before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a1a1aa;
}

.tut-topico-titulo {
  font-weight: 600;
}

.tut-item.tom-ok,
.tut-topico.tom-ok { border-color: #2e9e5b; }
.tut-topico.tom-ok::before { background: #2e9e5b; }

.tut-item.tom-nok,
.tut-topico.tom-nok { border-color: #d24444; }
.tut-topico.tom-nok::before { background: #d24444; }

.tut-item.tom-warn,
.tut-topico.tom-warn { border-color: #d1a324; }
.tut-topico.tom-warn::before { background: #d1a324; }

.tut-item.tom-info,
.tut-topico.tom-info { border-color: #3b82c4; }
.tut-topico.tom-info::before { background: #3b82c4; }

.tut-prints {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 18px;
}

.tut-print {
  position: relative;
}

.tut-print img {
  width: 100%;
  border-radius: var(--rd-radius-sm);
  border: 1px solid #e4e4e7;
  display: block;
}

.tut-print-ponto {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--rd-accent, #3b82c4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
  cursor: default;
}
</style>
